import MultilineNotes from './MultilineNotes.yaml?component';
import TextTemplate from './TextTemplate.yaml?component';
import TextTemplates from './TextTemplates.yaml?component';

export { MultilineNotes, TextTemplate, TextTemplates };
